import type { UserOut } from "./api";
import type { WorkConfirmationState } from "./screens/WorkScreen";

// Results never live in browser history. Only the current account can resolve
// the opaque handle; logout/account switch and process termination discard it.
const results = new Map<string, { owner: string; value: WorkConfirmationState }>();
export const SUCCESS_NOTICE_MS = 4_000;
const notices = new Map<string, { owner: string; value: string; successUntil: number | null; successLabel?: string }>();
const ownerKey = (user: UserOut) => `${user.id}:${user.workshop_id}`;
export function saveConfirmation(user: UserOut, value: WorkConfirmationState): string {
  const id = crypto.randomUUID();
  results.set(id, { owner: ownerKey(user), value });
  return id;
}
export function readConfirmation(user: UserOut, id?: string): WorkConfirmationState | null {
  const result = id ? results.get(id) : undefined;
  return result?.owner === ownerKey(user) ? result.value : null;
}
export function saveNotice(user: UserOut, value: string, success = false, successLabel?: string): string {
  const id = crypto.randomUUID();
  notices.set(id, { owner: ownerKey(user), value, successUntil: success ? Date.now() + SUCCESS_NOTICE_MS : null, successLabel });
  return id;
}
export function readNotice(user: UserOut, id?: string): string | null {
  const notice = id ? notices.get(id) : undefined;
  return notice?.owner === ownerKey(user) ? notice.value : null;
}
export function readNoticeDetails(user: UserOut, id?: string): { value: string; success: boolean; successUntil: number | null; successLabel?: string } | null {
  const notice = id ? notices.get(id) : undefined;
  return notice?.owner === ownerKey(user)
    ? { value: notice.value, success: notice.successUntil !== null && Date.now() < notice.successUntil, successUntil: notice.successUntil, successLabel: notice.successLabel } : null;
}
export function clearConfirmations() { results.clear(); notices.clear(); }
